import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Message } from "primereact/message";
import { candidateExamService } from "../../service/CandidateExam/candidateExam.service";

export default function StudentEntry() {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [confirmed, setConfirmed] = useState<{
    candidateName: string;
    examLink: string;
  } | null>(null);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError("");

    const trimmedCode = code.trim();
    if (!trimmedCode) {
      setError("Please enter your student code.");
      return;
    }

    setLoading(true);
    const res = await candidateExamService.generateExamLinkByCode({
      candidate_code: trimmedCode,
    });
    setLoading(false);

    if (!res.exam_link) {
      setError(res.error || "Invalid student code. Please try again.");
      return;
    }

    setConfirmed({ candidateName: res.candidate_name, examLink: res.exam_link });
  };

  const handleStartExam = () => {
    if (!confirmed) return;
    const url = new URL(confirmed.examLink);
    const token = url.searchParams.get("token");
    navigate(
      `/candidate-exam?token=${token}&name=${encodeURIComponent(confirmed.candidateName)}`
    );
  };

  return (
    <div className="flex justify-content-center align-items-center p-3">
      <Card title="Start Your Exam" className="p-4 w-full md:w-4">
        {confirmed ? (
          <div className="flex flex-column gap-4">
            <Message
              severity="success"
              text={`Welcome, ${confirmed.candidateName}`}
              className="w-full"
            />
            <p className="m-0">
              Your exam link is ready. Click <strong>Start Exam</strong> to
              begin.
            </p>
            <Button
              label="Start Exam"
              icon="pi pi-play"
              className="w-full"
              onClick={handleStartExam}
            />
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="flex flex-column gap-4">
            <div className="flex flex-column gap-2">
              <label htmlFor="studentCode">Student Code</label>
              <InputText
                id="studentCode"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                placeholder="Enter your 8-character student code"
                className="w-full"
                maxLength={8}
                autoFocus
              />
            </div>

            {error && <Message severity="error" text={error} />}

            <Button
              label="Generate Exam Link"
              type="submit"
              icon="pi pi-link"
              loading={loading}
              className="w-full"
            />
          </form>
        )}
      </Card>
    </div>
  );
}
